import React from 'react';
import { observer } from 'mobx-react';
import './style.scss';

import image from '@/assets/img/general_warning_icon.svg';

@observer
export default class Tip extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {content} = this.props;
    return <div className="tip-warning tip-err">
      <img src={image} className="icon" />
      <div className="content">{content}</div>
    </div>;
  }
}
